import Marionette from 'backbone.marionette';
import core_layouts from '../../../../core/layouts';
import pages, { AdvertisingView } from '../../views';
import { Subscription as SubscriptionModel } from '../../models';
// import { sizes_for_big_ad } from '../../../../core/utils';

export default class AccountController extends Marionette.Object {

	settings() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			accountSettings = new pages.AccountSettings(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'my-account-ad-slot-1',
				ad_path:'my-account',
				size: [300, 250],
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'div-gpt-ad-1607993845682-0',
				ad_path:'my-account',
				size: [[160, 600], [300, 250], [970, 250], [728, 90]],
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);
		rightSidebarLayout.getRegion('content').show(accountSettings);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	communications() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			communications = new pages.CommunicationsView(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'my-account-ad-slot-1',
				ad_path:'my-account',
				size: [300, 250],
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'div-gpt-ad-1607993845682-0',
				ad_path:'my-account',
				size: [[160, 600], [300, 250], [970, 250], [728, 90]],
				pos: 3,
			});

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		rightSidebarLayout.getRegion('content').show(communications);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	coachSettings() {
		const
			rootView = this.getOption('rootView'),
			rightSidebarLayout = new core_layouts.RightSidebar(),
			coachView = new pages.CoachView({
				subscription: new SubscriptionModel()
			}),
			coachHeaderView = new pages.CoachHeaderView(),
			coachDescriptionView = new pages.CoachDescriptionView(),
			coachSubscriptionTypeView = new pages.CoachSubscriptionTypeView(),
			coachFeaturesView = new pages.CoachFeaturesView(),
			coachFormTableView = new pages.CoachFormTableView(),
			widgetsSidebar = new core_layouts.WidgetsSidebar(),
			advertisingSidebar = new AdvertisingView({
				ad_id: 'my-account-ad-slot-1',
				ad_path:'my-account',
				size: [300, 250],
				pos: 2,
			}),
			advertisingFooter = new AdvertisingView({
				ad_id: 'div-gpt-ad-1607993845682-0',
				ad_path:'my-account',
				size: [[160, 600], [300, 250], [970, 250], [728, 90]],
				pos: 3,
			})
		;

		widgetsSidebar.getRegion('ads_container').show(advertisingSidebar);

		coachView.getRegion('header').show(coachHeaderView);
		coachView.getRegion('description').show(coachDescriptionView);
		coachView.getRegion('coach_type').show(coachSubscriptionTypeView);
		coachView.getRegion('features').show(coachFeaturesView);
		coachView.getRegion('coach_form_table').show(coachFormTableView);


		rightSidebarLayout.getRegion('content').show(coachView);
		rightSidebarLayout.getRegion('sidebar').show(widgetsSidebar);

		rootView.getRegion('main').show(rightSidebarLayout);
		rootView.getRegion('ads_container').show(advertisingFooter);
	}

	myHistory() {

	}

	changePassword() {

	}

	unsubscribe() {

	}
}